import { Table as TableUI, Tag, Spin } from 'antd';
import { Container } from 'components';
import { GetPumpWatersState } from 'apollo/configuration';
import { I18n } from 'i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { Turn } from 'pages/motor-pumps/components';

const { Column } = TableUI;

const CURRENTSTATUS = {
  offline: { color: 'red' },
  processing: { color: 'yellow' },
  online: { color: 'green' },
};

export function Log() {
  const history = useHistory();
  const { data: datapump, loading, error } = GetPumpWatersState();

  if (error) history.push('/error-server');

  if (loading) return <Spin spinning={loading} />;

  return (
    <Container id="water-pump-log" style={{ padding: '20px' }}>
      <TableUI
        dataSource={datapump}
        pagination={datapump.length > 10 ? true : false}
        loading={loading}
        bordered
      >
        <Column title={I18n('name', true)} dataIndex={'name'} key={'name'} />
        <Column title={I18n('location', true)} dataIndex={'location'} key={'location'} />
        <Column
          title={I18n('current_status', true)}
          dataIndex={'device'}
          key={I18n('device', true)}
          render={(action, _value) => {
            const value = action?.current_status;
            if (!value) return I18n('not_apply');
            return (
              <Tag
                className="rk-tag"
                icon={<FontAwesomeIcon icon={faCircle} color={CURRENTSTATUS[value].icon} />}
                color={`${CURRENTSTATUS[value].color}`}
                key={value}
              >
                {I18n(value, true)}
              </Tag>
            );
          }}
        />
        <Column
          title={I18n('work', true)}
          key={'action'}
          render={(action) => {
            const disabled =
              action?.device?.current_status === 'processing' ||
              action?.device?.current_status === 'offline';
            return (
              <>
                <Turn
                  _id={action._id}
                  current_status={disabled}
                  power_status={action?.power_status}
                />
              </>
            );
          }}
        />
      </TableUI>
    </Container>
  );
}
